// 공유 어트리뷰션(누가 공유했는지 → 누가 유입/주문했는지) 추적용 헬퍼.
// 보안상 공유 링크에는 공유자 userId 대신 불투명 토큰(shareToken)만 노출하고,
// 공유자 식별은 공유 생성 퍼널 이벤트(PRODUCT_SHARE_CREATED)의 인증된 userId로 서버에 남긴다.

export const SHARE_TOKEN_PARAM = 'shareToken';
export const SHARED_PRODUCT_PARAM = 'sharedProductId';

export interface ShareAttribution {
  shareToken?: string;
  sharedProductId?: string;
}

export const createShareToken = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

// 공유 링크로 진입한 페이지의 현재 URL에서 어트리뷰션 값을 읽는다.
export const readShareAttribution = (): ShareAttribution => {
  if (typeof window === 'undefined') {
    return {};
  }

  const params = new URLSearchParams(window.location.search);
  return {
    shareToken: params.get(SHARE_TOKEN_PARAM) || undefined,
    sharedProductId: params.get(SHARED_PRODUCT_PARAM) || undefined,
  };
};
